<template>
  <v-dialog v-model="showDialog" persistent max-width="600">               
    <v-card>
      <v-card-title class="headline">Pro Feature</v-card-title>
      <v-card-text>
        <div>To enable Pro features please contact Recycling Insights <a href="mailto:sales@datacourage.com">sales team</a>.</div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" text @click.prevent="showDialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { showDialogBoolean } from '@/mixins/showDialog.js'

export default {
  name: 'ProFeature',
  mixins: [showDialogBoolean] 
}
</script>